module.exports = __webpack_public_path__ + "img/biaoqian_guojiajiguan.16f5e1e7.png";